import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

/**
 * @typedef MenuOptions
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, close: string }} [overlay]
 */

const MainMenu = {
    selector: '#header .main-nav',
    navButton: '#header .nav-button',
    overlay: {
        element: '#nav-overlay',
        close: '#nav-close',
    },
};

function moveMainNav() {
    const mainNav = document.getElementById('main-nav-wrapper');
    const overlay = document.getElementById('nav-content');
    const header = document.querySelector('#header .header_inside');
    const navButton = document.querySelector(MainMenu.navButton);

    if (getComputedStyle(navButton).display !== 'none') {
        if (mainNav.closest('#nav-content')) {
            return;
        }

        overlay.append(mainNav);
    } else {
        if (mainNav.closest('.header_inside')) {
            return;
        }

        header.append(mainNav);
    }
}

onDomReady(() => {
    new DropdownMenu(MainMenu);
    moveMainNav();
});

window.addEventListener('resize', () => {
    moveMainNav();
});
